import React, { useState } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql, Link } from "gatsby";
import { useIntl } from "react-intl";

import Facebook from "../images/svg/facebook.svg";
import Instagram from "../images/svg/instagram.svg";
import LanguageSwitcher from "./language-switcher.js";
import { defaultLanguage } from "../i18n";

const Header = () => {
  const data = useStaticQuery(graphql`
    query MainMenu {
      allWpMenu {
        nodes {
          menuItems {
            nodes {
              url
              id
              label
            }
          }
          locations
        }
      }
    }
  `);

  const intl = useIntl();
  const locale = defaultLanguage === intl.locale ? "/" : `/${intl.locale}/`;

  const [nav, showNav] = useState(false);

  const menuItems = data.allWpMenu.nodes
    .filter(
      (item) =>
        !!item.locations.includes(
          intl.locale === defaultLanguage
            ? "HEADER_MENU"
            : `HEADER_MENU___${intl.locale.toUpperCase()}`
        )
    )
    .map((item) =>
      item.menuItems.nodes.map((menu) => ({
        ...menu,
        url: menu.url.replace("/index.php", ""),
      }))
    )
    .flat();

  // Filter out 'Languages' menu Items
  const filteredMenuItems = menuItems.filter((item) => 
      item.label !== "Languages"
    );

    const MenuList = () => {
      return (
        <ul>
          {filteredMenuItems.map((item) => {

            return (
              <li key={item.id}>
                <Link to={item.url}>{item.label}</Link>
              </li>
            );

          })}
        </ul>
      )
    }

  return (
    <>
      <div id="mobile-header">
        <div
          className="mobile-header__menu-toggle"
          onClick={() => {
            showNav(!nav);
          }}
          onKeyDown={() => {
            showNav(!nav);
          }}
          role="button"
          tabIndex="-1"
          aria-label="Open Mobile Menu"
        >
          <span />
          <span />
          <span />
        </div>
        <nav className={`mobile-header__nav ${nav ? "open" : "closed"}`}>
          <div className="mobile-header__navtop">
            <div className="mobile-header__navtop-social">
              <a
                href="https://www.facebook.com/TrendsCatchers/"
                target="_blank"
                rel="noreferrer"
              >
                <Facebook color="#fff" height="16px" />
              </a>
              <a
                href={`https://www.instagram.com/trendscatchers/?hl=${intl.locale}`}
                target="_blank"
                rel="noreferrer"
              >
                <Instagram color="#fff" height="18px" />
              </a>
            </div>
            <div
              className="close"
              onClick={() => {
                showNav(!nav);
              }}
              onKeyDown={() => {
                showNav(!nav);
              }}
              role="button"
              tabIndex="-1"
              aria-label="Close Mobile Menu"
            />
          </div>
          <MenuList />
        </nav>
        <Link to={`${locale}`}>
          <div className="logo" />
        </Link>
        <div className="mobile-header__language-switcher">
          {process.env.GATSBY_MULTILINGUAL === 'true' && (
            <LanguageSwitcher />
            )}
        </div>
      </div>
      <header id="header">
        <div className="container">
          <Link to={`${locale}`}>
            <div className="logo" />
          </Link>
          <nav id="navigation">
          <MenuList />
          </nav>
              <div className="language-switcher">
                {process.env.GATSBY_MULTILINGUAL === 'true' && (
                  <LanguageSwitcher />
                )}
              </div>
        </div>
      </header>
    </>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
